import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  title: {
    marginBottom: 16
  },
  number: {
    marginBottom: 8
  },
  hours: {
    paddingBottom: 16,
    borderBottom: `1px solid ${theme.colorPalette.beige_60}`
  },
  body: {
    marginTop: 16
  },
  bold: {
    fontWeight: 600
  },
  notificationCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: '!important start'
  },
  cardContainer: {
    width: '100%',
    marginTop: theme.spacing(4),
    padding: theme.spacing(4, 4, 4, 4),
    backgroundColor: theme.colorPalette.beige_10,
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start'
  },
  icon: { marginRight: theme.spacing(2) }
}));

export default useStyles;
